<template>
  <ais-instant-search :search-client="searchClient" :index-name="algoliaIndexName">
    <ais-search-box class="search-box" placeholder="Search products here..." />
    <ais-state-results class="search-result">
      <template slot-scope="{ query }">
        <ais-hits v-if="query.length > 0">
          <v-list v-if="items.length > 0" slot-scope="{ items }" elevation="3" :width="$vuetify.breakpoint.mdAndDown ? 320 : 600">
            <v-list-item v-for="item in items" :key="item.title" :to="{ name: 'ProductDetail', params: { id: item.objectID } }">
              <v-list-item-avatar v-if="item.image">
                <v-img :src="item.image"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
                <v-list-item-subtitle class="blue--text">Points: {{ item.points }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list v-else>
            <v-list-item link>
              Sorry, no result found.
            </v-list-item>
          </v-list>
        </ais-hits>
        <div v-else />
      </template>
    </ais-state-results>
  </ais-instant-search>
</template>

<script>
  import algoliasearch from "algoliasearch";
  import "instantsearch.css/themes/algolia-min.css";

  export default {
    name: "ProductSearchBar",

    props: {
      items: {
        type: Array,
      },
    },

    data() {
      return {
        algoliaIndexName: process.env.ALGOLIA_INDEX,

        searchClient: algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_API_KEY),
      };
    },

    computed: {
      algoliaIndex() {
        return this.searchClient.initIndex(this.algoliaIndexName);
      },
    },

    created() {
      if (this.items && !this.$validator.isEmptyArray(this.items)) {
        let newItems = this.items;

        newItems.forEach((item) => (item.objectID = item.id));

        this.algoliaIndex.saveObjects(newItems).then(({ objectIDs }) => {});
      }
    },
  };
</script>

<style scoped>
  .search-box {
    max-width: 600px;
  }
  .search-result {
    position: absolute;
    z-index: 5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Catalog/ProductSearchBar.vue